import React, { useRef } from "react"
import { Heading, Text, Flex, Box } from "@chakra-ui/react"
import { format } from "date-fns"
import Carousel, { ResponsiveType } from "react-multi-carousel"
import ResponsiveBlock from "~components/shared/layout/responsive-block"

const BlogFooter: React.FC<{
    allBlogs: Queries.ContenfulBlogPostQuery["allContentfulBlogPost"]
}> = ({ allBlogs }) => {
    const mousePos = useRef({ x: 0, y: 0 })

    const responsive: ResponsiveType = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1440 },
            items: 4,
            partialVisibilityGutter: 10,
        },
        desktop: {
            breakpoint: { max: 1440, min: 1024 },
            items: 3,
            partialVisibilityGutter: 60,
        },
        laptop: {
            breakpoint: { max: 1024, min: 768 },
            items: 2,
            partialVisibilityGutter: 120,
        },
        tablet: {
            breakpoint: { max: 768, min: 680 },
            items: 2,
            partialVisibilityGutter: 70,
        },
        largeMobile: {
            breakpoint: { max: 680, min: 590 },
            items: 2,
            partialVisibilityGutter: 30,
        },
        mediumMobile: {
            breakpoint: { max: 590, min: 464 },
            items: 1,
            partialVisibilityGutter: 100,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 70,
        },
    }

    return (
        <ResponsiveBlock mt={12} mb={24}>
            <Heading as="h2" size="lg" fontWeight="600" mt={8} mb={4}>
                More from the Chckvet Blog
            </Heading>
            <Box mb={6} w="100%" userSelect={"none"}>
                <Carousel
                    // centerMode={isSmall}
                    arrows={true}
                    customTransition="all 1s ease-in-out"
                    partialVisible={true}
                    draggable={true}
                    // minimumTouchDrag={80}

                    // pauseOnHover
                    responsive={responsive}
                    swipeable
                >
                    {allBlogs?.nodes.map((post: any) => {
                        console.log(post.featuredImage?.url)

                        return (
                            <Flex
                                key={post.id}
                                minW="240px"
                                maxW="240px"
                                h="160px"
                                // bgGradient={`linear(45deg, ${bgColor}.600, ${bgColor}.300)`}
                                bgImage={`linear-gradient(180deg, rgba(0,0,0,0) 5%, rgba(0,0,0,0.07) 17%, rgba(0,0,0,0.35) 40%, rgba(0,0,0,0.7) 100%), url('${post.featuredImage?.url}')`}
                                bgPos={"center"}
                                bgSize="cover"
                                as="a"
                                draggable="false"
                                href={`/blog/${post.slug}`}
                                _hover={{
                                    textDecoration: "none",
                                }}
                                color="white"
                                borderRadius={16}
                                p={3}
                                flexDir="column"
                                shadow="lg"
                                pos="relative"
                                userSelect={"none"}
                                onMouseDown={e => {
                                    mousePos.current.x = e.clientX
                                    mousePos.current.y = e.clientY
                                }}
                                onClick={e => {
                                    if (
                                        Math.abs(
                                            e.clientX - mousePos.current.x
                                        ) > 10 ||
                                        Math.abs(
                                            e.clientY - mousePos.current.y
                                        ) > 10
                                    ) {
                                        e.preventDefault()
                                        return
                                    }
                                }}
                            >
                                <Heading
                                    userSelect={"none"}
                                    mt="auto"
                                    size="sm"
                                    fontWeight="semibold"
                                    noOfLines={2}
                                >
                                    {post.title}
                                </Heading>
                                <Text
                                    userSelect={"none"}
                                    color="gray.100"
                                    size="sm"
                                    lineHeight={"shorter"}
                                    noOfLines={2}
                                >
                                    {post.shortDescription}
                                </Text>
                                <Text
                                    userSelect={"none"}
                                    fontSize="xs"
                                    color="gray.200"
                                    pos="absolute"
                                    bg="rgba(0,0,0,0.3)"
                                    backdropFilter={"blur(12px)"}
                                    border={"1px solid"}
                                    borderTopColor="whiteAlpha.400"
                                    borderLeftColor="whiteAlpha.300"
                                    borderRightColor="whiteAlpha.300"
                                    borderBottomColor="blackAlpha.100"
                                    borderRadius="full"
                                    top="8px"
                                    right="8px"
                                    px={2}
                                >
                                    {format(
                                        new Date(post.publicationDate),
                                        "MMM d, yyyy"
                                    )}
                                </Text>
                            </Flex>
                        )
                    })}
                </Carousel>
                <Flex
                    flexDir="row"
                    gridGap={4}
                    overflow="hidden"
                    maxW="100%"
                ></Flex>
            </Box>
        </ResponsiveBlock>
    )
}

export default BlogFooter
